import { Picture, theme, VerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

import { Wrapper as WrapperBase } from 'src/components/page-headers/styles'

export const Wrapper = styled(WrapperBase)`
  position: relative;
  overflow: hidden;
  padding-bottom: 25vw;

  @media ${theme.breakpoints.medium} {
    padding-bottom: 15vw;
  }
`

export const Content = styled(VerticalSpacer).attrs({
  amount: { small: 24, medium: 32, large: 40 },
})`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const Points = styled.div`
  display: flex;
  margin: -8px;
  flex-direction: column;
  align-items: center;

  @media ${theme.breakpoints.large} {
    flex-direction: row;
  }

  > * {
    margin: 8px;

    @media ${theme.breakpoints.large} {
      margin: 16px;
    }
  }
`

export const BackgroundImage = styled(Picture)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`
